import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';
import { observer } from 'mobx-react';

export const GetFullVariantsBySkuQuery = gql`
  query variants($skuIn: [String!], $country: String, $currency: String) {
    variants(where: { sku_in: $skuIn, countryId: $country, currencyId: $currency }) {
      id
      ean
      sku
      definition
      inStock
      price
      recommendedPrice
      prices
      product {
        id
        title
        name
        technicalSpecification
        subtitle
        slug
        description
        display
        status
        price
        prices
        recommendedPrice
        tags
        sku
        weight
        weightForShipping
        images {
          id
          file
          priority
          createdAt
          values {
            id
          }
        }
        availability {
          id
          name
          title
          color
        }
        neverApplyCustomerDiscounts
      }
      attributeValues {
        id
        value
        title
        attribute {
          id
          isVisual
        }
      }
    }
  }
`;

interface IInputProps {
  children?: any;
  ids: Array<string>;
  categoryId: string;
}

interface IResponse {
  data: any;
}

@observer
class VariantsQuery extends React.Component<ChildProps<IInputProps, IResponse>, {}> {

  public render() {
    const { fullVariantsBySku }: any = this.props;
    return this.props.children({ fullVariantsBySku });
  }
}

export default compose(
  graphql<IInputProps, IResponse>(GetFullVariantsBySkuQuery, {
    name: 'fullVariantsBySku',
  })
)(VariantsQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Products/FullVariantsBySku.tsx